import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { queryKey } from 'constants/queryKey';
import PostApi from 'api/post';
import { areTranslatedImagesApplied } from 'app/modules/posts/utils/translatedImageCards';
import type { TranslationJobResponse } from 'types/AiHubTranslation';

type AppliedState = {
  postText: boolean;
  firstComment: boolean;
  images: boolean;
};

export const useTranslationAppliedState = (
  postId: number,
  translationJob?: TranslationJobResponse,
): AppliedState => {
  const { data: postDetail } = useQuery(queryKey.postDetail(postId), () =>
    PostApi.detail(postId),
  );

  return useMemo(() => {
    if (!postDetail || !translationJob?.fields) {
      return { postText: false, firstComment: false, images: false };
    }

    const postTextApplied =
      !!translationJob.fields.postText?.translated &&
      postDetail.raw_text === translationJob.fields.postText.translated;

    const firstCommentApplied =
      !!translationJob.fields.firstComment?.translated &&
      postDetail.attachments?.firstComment?.text ===
        translationJob.fields.firstComment.translated;

    const imagesApplied = areTranslatedImagesApplied(
      postDetail.attachments?.cards ?? [],
      translationJob.fields.images ?? [],
    );

    return {
      postText: postTextApplied,
      firstComment: firstCommentApplied,
      images: imagesApplied,
    };
  }, [postDetail, translationJob]);
};
